import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithProviderCountry } from "@/redux/baseQuery";

export const pricingApi = createApi({
  reducerPath: "pricingApi",
  baseQuery: baseQueryWithProviderCountry(),
  endpoints: () => ({}),
});
